function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 12C16.343 12 15 13.343 15 15V33C15 33.1318 15.0261 33.2623 15.0767 33.3839C15.1273 33.5056 15.2015 33.6161 15.2949 33.709C15.6478 34.973 16.6304 36 18 36H20V39L21.5 38L23 39V35.168C23.0178 35.06 23.0178 34.9498 23 34.8418V33H20V34H18C17.435 34 17 33.565 17 33C17 32.435 17.435 32 18 32H29V12H18ZM31 12V32H33C34.105 32 35 31.105 35 30V14C35 12.895 34.105 12 33 12H31ZM25 34V36H34C34.2652 36 34.5196 35.8946 34.7071 35.7071C34.8946 35.5196 35 35.2652 35 35C35 34.7348 34.8946 34.4804 34.7071 34.2929C34.5196 34.1054 34.2652 34 34 34H25Z"
});

function SvgIc5D5F8Bb8Fc0611Eb9A030242Ac130003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc5D5F8Bb8Fc0611Eb9A030242Ac130003);
export default ForwardRef;